import { Redirect, useLocation, useParams } from 'react-router-dom';

export function AdminAccountEditAutomationTemplate() {
	const location = useLocation();
	const { accountId, id } = useParams<{ accountId: string; id: string }>();

	if (!accountId || !id) {
		return null;
	}

	return (
		<Redirect
			to={{
				pathname: `/accounts/${accountId}/automations/${id}/canvas`,
				search: location.search,
				hash: location.hash,
				state: location.state,
			}}
		/>
	);
}
